module.exports = __webpack_public_path__ + "664de3932dd6291b4b8a8c0ddbcb4c61.svg";